import { Text } from '@capsicum/common-web';

import * as S from './WCPledgeTabs.styled';

export const WCPledgeBundlesTab = () => {
	return (
		<S.TabContentContainer>
			<Text variant="text3">Bundles Tab</Text>
		</S.TabContentContainer>
	);
};
